var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Slashed_Eye",
    "data-name": "Slashed Eye",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8316",
    "data-name": "Rectangle 8316",
    width: 24,
    height: 24,
    transform: "translate(253 750)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6687",
    "data-name": "Mask Group 6687",
    transform: "translate(-253 -750)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eye-slash-solid",
    d: "M10.867,13.579a4.871,4.871,0,0,1-4.852-4.52L2.453,6.306A11.317,11.317,0,0,0,1.206,8.194a1.1,1.1,0,0,0,0,.991,10.891,10.891,0,0,0,9.661,6.024,10.547,10.547,0,0,0,2.645-.355L11.75,13.491a4.894,4.894,0,0,1-.883.089Zm10.656,1.973-3.754-2.9a11.248,11.248,0,0,0,2.759-3.466,1.1,1.1,0,0,0,0-.991A10.891,10.891,0,0,0,10.867,2.17a10.464,10.464,0,0,0-5,1.28L1.545.111a.543.543,0,0,0-.763.1l-.667.858a.543.543,0,0,0,.1.762L20.19,17.268a.543.543,0,0,0,.763-.1l.667-.858A.543.543,0,0,0,21.523,15.552ZM15.285,10.73,13.951,9.7a3.218,3.218,0,0,0-3.943-4.14,1.618,1.618,0,0,1,.316.958,1.584,1.584,0,0,1-.052.34l-2.5-1.932a4.832,4.832,0,0,1,3.1-1.124,4.887,4.887,0,0,1,4.89,4.89,4.774,4.774,0,0,1-.472,2.041Z",
    transform: "translate(254.133 753.311)",
    fill: "#102d6f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.ca5a64433e773f8f51e8b2910eff6288.svg";
export { ForwardRef as ReactComponent };